import { memo, useEffect } from "react"
import { useAtom } from 'jotai';
import { headerCenter_currentState_Atom, HeaderCenter_State } from "../store";
import { elementType_Atom, showElementPanel_Atom } from "./store";
import { ElementPanelUtil } from "./ElementPanelUtil";
import { IoChevronDown } from "react-icons/io5";
import { HeaderCenterStyles } from "../HeaderCenterStyle";
import ElementPanel from "./ElementPanel";
import { TerraDrawUtil } from "~/components/MapDraw/TerraDrawUtil";
import { showElementDetailPanelAtom } from "~/components/Map/stores/mapStore";
import { Element_create_Request, ElementAPIs } from "~/common/typescript/apis/ElementAPIs";
import { currentProjectAtom } from '~/stores/ProjectStore';
import styled from "styled-components";
import { ElementMapUtilOptimized } from "~/components/Map/Element/ElementMapUtilOptimized";
import { Element_Base } from "~/common/typescript/models/Element";
import { elementsAtom } from "~/components/Map/Element/ElementStore";
import { isMapLoadedDoneAtom } from "~/components/Map/stores/mapStore";

let globalOnDrawFinish: Function;
const ElementHeaderItem = () => {
  const [currentState, setCurrentState] = useAtom(headerCenter_currentState_Atom);
  const [showElementPanel, setShowElementPanel] = useAtom(showElementPanel_Atom);
  const [elementMode, setElementMode] = useAtom(elementType_Atom);
  const [currentProject, setCurrentProject] = useAtom(currentProjectAtom);
  const [elements, setElements] = useAtom<Element_Base[]>(elementsAtom);
  const [isMapLoadedDone, setMapLoadedDone] = useAtom(isMapLoadedDoneAtom);

  const [showElementDetailPanel, setShowElementDetailPanel] = useAtom(showElementDetailPanelAtom);

  const onDrawFinish = async (id: string) => {
    const isActive = currentState == HeaderCenter_State.ELEMENT;
    if (!isActive) return;

    const feature = TerraDrawUtil.getFeatureById(id);
    const request: Element_create_Request = {
      project_id: currentProject.id!,
      type: elementMode,
      geojson: feature?.geometry as object,
    };
    const response = await ElementAPIs.remote_create(request);
    const element = await ElementAPIs.remote_getOne(response.data?.uuid!);
    // if (element) {
    //   ElementMapUtilOptimized.addElementToMap(element);
    // }
    TerraDrawUtil.removeFeature(id);
    setShowElementDetailPanel(true);
    return element;
  }

  globalOnDrawFinish = onDrawFinish;

  useEffect(() => {
    if (window.map) {
      if (window.draw) {
        return;
      }
      TerraDrawUtil.setup();

      // setup TerraDraw event
      {
        window.draw?.on("finish", async (id: string, context: { action: string, mode: string }) => {
          if (context.action === 'draw') {
            const element = await globalOnDrawFinish(id);
            if (element) {
              setElements((prev) => [...prev, element]);
            }
          } else if (context.action === 'dragFeature') {
            // Do something for a drag finish event
          } else if (context.action === 'dragCoordinate') {
            //
          } else if (context.action === 'dragCoordinateResize') {
            //
          }
        });
      }
    }
  }, [isMapLoadedDone]);

  return (<HeaderCenterStyles.UI_Item className={`element-header-item ${currentState == HeaderCenter_State.ELEMENT ? 'active' : ''} `}>
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', flex: 1 }}>
      <UI_Item style={{ justifyContent: 'flex-end' }} onClick={() => {
        if (currentState == HeaderCenter_State.ELEMENT) {
          setCurrentState(HeaderCenter_State.NONE);
          setShowElementPanel(false);
        } else {
          setCurrentState(HeaderCenter_State.ELEMENT);
        }
      }}>
        {ElementPanelUtil.getIcon(elementMode)}
      </UI_Item>

      {/* <Tooltip title="Tạo đối tượng"> */}
      <UI_Item onClick={() => {
        setShowElementPanel(!showElementPanel);
      }} style={{ justifyContent: 'flex-start' }}>
        <IoChevronDown size={10} />
      </UI_Item>

      {/* </Tooltip> */}
    </div>


    {showElementPanel && <ElementPanel />}
  </HeaderCenterStyles.UI_Item>
  );
}

export default memo(ElementHeaderItem);

const UI_Item = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  flex: 1;
`